import { createFrontendModule } from '@backstage/frontend-plugin-api';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';

const systemPickerFormField = FormFieldBlueprint.make({
  name: 'system-picker',
  params: {
    field: () =>
      import('./SystemPickerFieldExtension').then(m => m.SystemPicker),
  },
});

const giteaRepoPickerFormField = FormFieldBlueprint.make({
  name: 'gitea-repo-picker',
  params: {
    field: () =>
      import('./GiteaRepoPickerFieldExtension').then(m => m.GiteaRepoPicker),
  },
});

export const scaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    scaffolderPlugin.getExtension('page:scaffolder').override({
      params: {
        loader: async () =>
          import('./ServiceTemplatesPage').then(m => <m.ServiceTemplatesPage />),
      },
    }),
    systemPickerFormField,
    giteaRepoPickerFormField,
  ],
});
